import { createFileRoute } from "@tanstack/react-router";
import Financeiro from "@/pages/admin/Financeiro";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/admin/financeiro")({
  head: () => pageHead({ title: "Financeiro | Painel", path: "/admin/financeiro", noindex: true }),
  component: Financeiro,
});
